import { formatDate } from '../../../helpers/formatDate'
import { InventorySystemTypes } from '../../../types'
import type { VenueDTO, EditRowDef } from '../../../types'

const ispTypeOptions = Object.values(InventorySystemTypes).map((v) => ({
  value: v,
  label: v,
}))

const statusOptions = [
  { value: 'OKAY', label: 'OKAY' },
  { value: 'OFFSALE', label: 'OFFSALE' },
]

export function buildVenueEditRows(venue: VenueDTO): EditRowDef[] {
  return [
    {
      mode: 'editable',
      field: {
        name: 'id',
        label: 'ID',
        type: 'text',
        required: true,
        isDisabled: true,
      },
      initialValue: venue.id,
    },
    {
      mode: 'editable',
      field: {
        name: 'sysVenueId',
        label: 'Sys Venue ID',
        type: 'text',
        required: true,
      },
      initialValue: venue.sysVenueId,
    },
    {
      mode: 'editable',
      field: {
        name: 'name',
        label: 'Name',
        type: 'text',
        required: true,
      },
      initialValue: venue.name,
    },
    {
      mode: 'editable',
      field: {
        name: 'venueSlug',
        label: 'Venue Slug',
        type: 'text',
        required: true,
        isDisabled: true,
      },
      initialValue: venue.venueSlug,
    },
    {
      mode: 'editable',
      field: {
        name: 'status',
        label: 'Status',
        type: 'select',
        options: statusOptions,
        required: true,
      },
      initialValue: venue.status,
    },
    {
      mode: 'editable',
      field: {
        name: 'timezone',
        label: 'Timezone',
        type: 'text',
        required: true,
      },
      initialValue: venue.timezone,
    },
    {
      mode: 'editable',
      field: {
        name: 'latitude',
        label: 'Latitude',
        type: 'number',
        required: true,
      },
      initialValue: venue.latitude,
    },
    {
      mode: 'editable',
      field: {
        name: 'longitude',
        label: 'Longitude',
        type: 'number',
        required: true,
      },
      initialValue: venue.longitude,
    },
    {
      mode: 'editable',
      field: {
        name: 'type',
        label: 'Type',
        type: 'select',
        options: [{ value: 'theatre', label: 'theatre' }],
        required: true,
      },
      initialValue: venue.type,
    },
    {
      mode: 'editable',
      field: {
        name: 'inventorySystemType',
        label: 'ISP Type',
        type: 'select',
        options: ispTypeOptions,
        required: true,
      },
      initialValue: venue.inventorySystemType,
    },
    { mode: 'readonly', label: 'Created', value: formatDate(venue.createdAt) },
    { mode: 'readonly', label: 'Updated', value: formatDate(venue.updatedAt) },
  ]
}
